module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-image-1-533x800-d1bddd648fc1fb749bbbfb348bd8bf59.jpg";